import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";

import ChatIssuesTableMainHeader from "./ChatIssuesTableMainHeader";
import ChatIssueTableHeaders from "./ChatIssueTableHeaders";
import ChatIssueTableRows from "./ChatIssueTableRows";
import { Alert, Stack, TableCell, TableRow, Typography } from "@mui/material";
const ChatMetricIssuesTable = (props: any) => {
  const { title, time, feedbacks, MostReferedArticlesData } = props;
  //reportsTicketsData
  const reportsTicketsData = [
    {
      "topic": "High Rebuffering",
      "body": "First Item",
      "severity": 1,
      "status": 0,
    },
    {
      "topic":
        "https://help.yitechnology.com/hc/en-us/articles/1260803442770-Getting-to-know-your-Kami-Wire-Free-Outdoor-Camera",
      "body": "Second Item",
      "severity": 2,
      "status": 1,
    },
  ];
  return (
    <Box sx={{ border: "1px solid #ccc", borderRadius: "10px" }}>
      <ChatIssuesTableMainHeader title={title} time={time} />
      <TableContainer>
        {/* component={Paper} */}
        <Table>
          <TableHead>
            <ChatIssueTableHeaders />
          </TableHead>
          {MostReferedArticlesData.length > 0 ? (
            <TableBody>
              {MostReferedArticlesData &&
                MostReferedArticlesData.map((data: any) => {
                  return <ChatIssueTableRows reportsTicketsData={data} />;
                })}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#272727d1",
                  }}
                >
                  No data found{" "}
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ChatMetricIssuesTable;
